/**
 * Maps ERP entity and document record identifiers to client routes.
 * Used for drill-through navigation from AI chat breadcrumbs, tables, and evidence.
 */
export function resolveDocumentRoute(recordId: string, base = ''): string | null {
  const cleanId = recordId.trim();
  const prefix = cleanId.split('-')[0]?.toUpperCase();
  const root = base.replace(/\/+$/, '');
  switch (prefix) {
    case 'SO':
    case 'ORD':
      return `${root}/sales/orders/${cleanId}`;
    case 'INV':
      return `${root}/sales/invoices/${cleanId}`;
    case 'SQ':
    case 'QUO':
      return `${root}/sales/quotes/${cleanId}`;
    case 'PO':
      return `${root}/procurement/orders/${cleanId}`;
    case 'PR':
      return `${root}/procurement/requests/${cleanId}`;
    case 'JE':
      return `${root}/finance/journals/${cleanId}`;
    case 'PRJ':
      return `${root}/projects/list/${cleanId}`;
    case 'TSK':
      return `${root}/projects/tasks/${cleanId}`;
    case 'CUS':
      return `${root}/sales/customers/${cleanId}`;
    case 'SUP':
      return `${root}/procurement/suppliers/${cleanId}`;
    case 'ITEM':
    case 'WH':
      return `${root}/inventory/items/${cleanId}`;
    default:
      return null;
  }
}
